import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=230284b7&scoped=true&"
import script from "./caseDetail.vue?vue&type=script&lang=js&"
export * from "./caseDetail.vue?vue&type=script&lang=js&"
import style0 from "./caseDetail.vue?vue&type=style&index=0&id=230284b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230284b7",
  null
  
)

export default component.exports